<ion-header>
  <ion-toolbar mode="md">
    <ion-title>Asistence: {{ assistance.client?.user?.firstName }} {{ assistance.client?.user?.lastName }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- FAB -->
  <!-- TODO LATER extract to separate component ideally-->
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    @if (fab.states[RoleAssistantFabState.working]) {
      <ion-button class="fab" color="secondary">
        <ion-spinner name="bubbles"></ion-spinner>
      </ion-button>
    }

    @if (fab.states[RoleAssistantFabState.assistanceReadyToBeConfirmed]) {
      <ion-button class="fab" (click)="confirmAssistance()" color="secondary">
        <ion-icon name="checkmark"></ion-icon>
        <span>Potvrdit asistenci</span>
      </ion-button>
    }

    @if (fab.states[RoleAssistantFabState.assistanceReadyToStart]) {
      <ion-button class="fab" (click)="startAssistance()" color="secondary">
        <ion-icon name="play"></ion-icon>
        <span>Začít asistenci</span>
      </ion-button>
    }

    @if (fab.states[RoleAssistantFabState.assistanceReadyToEnd]) {
      <ion-button class="fab" (click)="askEndAssistance()" color="secondary">
        <ion-icon name="stop"></ion-icon>
        <span>Ukončit asistenci</span>
      </ion-button>
    }
  </ion-fab>

  <!-- FAB END -->

  <ion-list id="list" lines="full" class="accomodate-toolbar-above ion-no-margin ion-no-padding">
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label>Plánovaný čas asistence</ion-label>
            <div slot="end" id="plannedDate">
              <app-date-range-view
                [startDate]="assistance.plannedFrom"
                [endDate]="assistance.plannedTo"
              ></app-date-range-view>
            </div>
          </ion-item>
        </ion-col>
      </ion-row>

      @if (assistance.realizedFrom) {
        <ion-row>
          <ion-col size="12">
            <ion-item>
              <ion-label>Skutečný čas asistence</ion-label>
              <div slot="end" id="realizedDate">
                <app-date-range-view
                  [startDate]="assistance.realizedFrom"
                  [endDate]="assistance.realizedTo"
                ></app-date-range-view>
              </div>
            </ion-item>
          </ion-col>
        </ion-row>
      }

      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label>Stav</ion-label>
            <span [style.backgroundColor]="assignment?.status?.color" class="status-colored">
              {{ assignment?.status?.humanReadableName }}
            </span>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label slot="start">Popis</ion-label>
            <span slot="end">{{ assistance.shortDescription }}</span>
          </ion-item>

          <ion-item>
            <ion-label>Kontakt na klienta</ion-label>
            {{ assistance.client | getPrimaryContact }}
          </ion-item>

          <ion-item>
            <ion-label>Koordinátor klienta</ion-label>
            {{ (keyCoordinator$ | async)?.fullName() }}
          </ion-item>

          @if (FeatureFlags.roleAssistantAssistanceEditor_showJournalEntryEditorNotice) {
            <ion-item class="justify-self-center">
              <ion-chip (click)="scrollToTagEditor()" color="secondary">
                <ion-label>Zpětná vazba je nyní "Můj deníkový zápis"</ion-label>
                <ion-icon name="arrow-down-outline"></ion-icon>
              </ion-chip>
            </ion-item>
          }

          <ion-item-divider>
            <ion-label>Adresa</ion-label>
          </ion-item-divider>

          <ion-item>
            <ion-label>Začátek</ion-label>
            {{ assistance.addressStart }}
          </ion-item>
          <ion-item>
            <ion-label>Konec</ion-label>
            {{ assistance.addressEnd }}
          </ion-item>

          <ion-item-divider>
            <ion-label></ion-label>
          </ion-item-divider>

          <ion-accordion-group [multiple]="true" (ionChange)="onAccordionChange($event)">
            @if (canWriteJournalEntry) {
              <ion-accordion #tagEditorAnchor>
                <ion-item slot="header">
                  <ion-label>{{ 'ASSISTANCE_CARE_LOG_EDITOR.MY_JOURNAL_ENTRY' | transloco }}</ion-label>
                  <ion-button
                    slot="end"
                    (click)="saveJournalEntry()"
                    [disabled]="savingJournalEntry || !isJournalEntryDirty"
                  >
                    {{ 'ASSISTANCE_CARE_LOG_EDITOR.SAVE_ENTRY' | transloco }}
                  </ion-button>
                </ion-item>
                <div slot="content">
                  <ion-item lines="none">
                    <app-tag-editor
                      class="ion-padding-top"
                      [ngModel]="myJournalEntry"
                      (ngModelChange)="onMyJournalEntryChange($event)"
                      [clientId]="assistance.clientId"
                      [placeholder]="'TAG_EDITOR.ENTER_NOTES_PLACEHOLDER' | transloco"
                    ></app-tag-editor>
                  </ion-item>
                </div>
              </ion-accordion>
            }

            <ion-accordion [disabled]="!assistance.realizedFrom">
              <ion-item slot="header">
                <ion-label>
                  {{ 'ASSISTANCE_CARE_LOG_EDITOR.TASKS' | transloco }}
                </ion-label>
                <ion-chip>
                  {{ totalCareLogMinutes }} {{ 'ASSISTANCE_CARE_LOG_EDITOR.TOTAL_MINUTES' | transloco }}
                </ion-chip>
              </ion-item>
              <ion-item slot="content" class="ion-padding-bottom">
                @if (assistance.id) {
                  <app-assistance-care-log-editor
                    [assignments]="mappedAssistantAssignment"
                    [assistanceId]="assistance.id"
                    [clientId]="assistance.clientId"
                    [role]="'assistant'"
                    [readonly]="!assistance.realizedFrom"
                    [currentAssistantId]="assistantId"
                    [maxTotalMinutes]="assistanceElapsedMinutes"
                    [(ngModel)]="totalCareLogMinutes"
                  />
                }
              </ion-item>
            </ion-accordion>

            @if (journalEntryHistoryEnabled$ | async) {
              <ion-accordion value="journal-history">
                <ion-item slot="header">
                  <ion-label>{{ 'ASSISTANCE_CARE_LOG_EDITOR.JOURNAL_ENTRY_HISTORY' | transloco }}</ion-label>
                </ion-item>
                <div slot="content">
                  @if (journalHistoryData$ | async; as history) {
                    @if (history.total === 0) {
                      <ion-item lines="none">
                        <ion-label color="medium">
                          {{ 'ASSISTANCE_CARE_LOG_EDITOR.JOURNAL_ENTRY_HISTORY_EMPTY' | transloco }}
                        </ion-label>
                      </ion-item>
                    } @else {
                      <ion-item lines="none">
                        <ion-buttons slot="start">
                          <ion-button [disabled]="history.skip >= history.total - 1" (click)="journalHistoryOlder()">
                            <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
                          </ion-button>
                        </ion-buttons>
                        <ion-label class="ion-text-center">{{ history.skip + 1 }} / {{ history.total }}</ion-label>
                        <ion-buttons slot="end">
                          <ion-button [disabled]="history.skip <= 0" (click)="journalHistoryNewer()">
                            <ion-icon slot="icon-only" name="chevron-forward"></ion-icon>
                          </ion-button>
                        </ion-buttons>
                      </ion-item>
                      <ion-item lines="none">
                        <ion-label>
                          <div
                            class="journal-history-content"
                            [innerHTML]="history.data[0]?.content ?? '' | bypassHtmlSanitizer"
                          ></div>
                          <p class="journal-history-meta">
                            {{ history.data[0]?.authorFullName }}
                            @if (history.data[0]?.dateTime) {
                              — {{ history.data[0].dateTime | date: 'd. M. yyyy' }}
                            }
                          </p>
                        </ion-label>
                      </ion-item>
                    }
                  }
                </div>
              </ion-accordion>
            }
          </ion-accordion-group>

          <ion-item-divider>
            <ion-label>Detailní popis výkonu</ion-label>
          </ion-item-divider>

          <ion-item>
            <app-assistance-attachments
              [assistanceId]="assistance.id"
              [readonly]="true"
              role="assistant"
            ></app-assistance-attachments>
          </ion-item>

          <ion-item>
            <div
              id="detailedDescription"
              [innerHTML]="assistance.detailedDescription ?? '' | bypassHtmlSanitizer"
            ></div>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-list>
</ion-content>
